// --- existing imports ---
import React, { useState, useEffect } from "react";
import { Switch, message, Card, Row, Col } from "antd";
import { getDocs, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";

const Settings = () => {
  const [publishCommittee, setPublishCommittee] = useState(false);
  const [publishInformation, setPublishInformation] = useState(false);
  const [publishSponsors, setPublishSponsors] = useState(false);
  const [enableLinkedInPost, setEnableLinkedInPost] = useState(false);
  const [isDev, setIsDev] = useState(false);
  const [closeRegistration, setCloseRegistration] = useState(false); // 🟢 new
  const [tempOpenSurvey, setTempOpenSurvey] = useState<boolean>(false); // 🟢 NEW

  // inside Settings component states
  const [closeHotelRegistration, setCloseHotelRegistration] =
    useState<boolean>(false);

  const fetchSettings = async () => {
    const settingsSnapshot = await getDocs(collection(db, "settings"));
    settingsSnapshot.docs.forEach((doc) => {
      const data = doc.data();
      setPublishCommittee(data.publishCommittee || false);
      setPublishInformation(data.publishInformation || false);
      setPublishSponsors(data.publishSponsors || false);
      setEnableLinkedInPost(data.enableLinkedInPost || false);
      setIsDev(data.isDev || false);
      setCloseRegistration(data.closeRegistration || false);
      setCloseHotelRegistration(data.closeHotelRegistration || false);
      setTempOpenSurvey(data.tempOpenSurvey || false); // 🟢 NEW
    });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleToggleChange = async (setting: string, value: boolean) => {
    try {
      const settingRef = doc(db, "settings", "settings");
      await updateDoc(settingRef, {
        [setting]: value,
      });
      message.success(`${setting} updated successfully!`);
    } catch (error) {
      console.error("Error updating settings:", error);
      message.error("Failed to update settings.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Settings</h1>

      <Row gutter={32}>
        {/* Existing toggles... */}
        <Col span={6}>
          <Card title="Publish Committee" bordered={false}>
            <Switch
              checked={publishCommittee}
              onChange={(checked) => {
                setPublishCommittee(checked);
                handleToggleChange("publishCommittee", checked);
              }}
            />
          </Card>
        </Col>

        {/* 🟢 NEW Close Registration toggle */}
        <Col span={6}>
          <Card title="Close Registration" bordered={false}>
            <Switch
              checked={closeRegistration}
              onChange={(checked) => {
                setCloseRegistration(checked);
                handleToggleChange("closeRegistration", checked);
              }}
            />
          </Card>
        </Col>

        <Col span={6}>
          <Card title="Close Hotel Registration" bordered={false}>
            <Switch
              checked={closeHotelRegistration}
              onChange={(checked) => {
                setCloseHotelRegistration(checked);
                handleToggleChange("closeHotelRegistration", checked);
              }}
            />
          </Card>
        </Col>

        <Col span={6}>
          <Card title="Publish Information" bordered={false}>
            <Switch
              checked={publishInformation}
              onChange={(checked) => {
                setPublishInformation(checked);
                handleToggleChange("publishInformation", checked);
              }}
            />
          </Card>
        </Col>

        <Col span={6}>
          <Card title="Publish Sponsors & Exhibitors" bordered={false}>
            <Switch
              checked={publishSponsors}
              onChange={(checked) => {
                setPublishSponsors(checked);
                handleToggleChange("publishSponsors", checked);
              }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={32} style={{ marginTop: 32 }}>
        <Col span={6}>
          <Card title="Enable LinkedIn Post" bordered={false}>
            <Switch
              checked={enableLinkedInPost}
              onChange={(checked) => {
                setEnableLinkedInPost(checked);
                handleToggleChange("enableLinkedInPost", checked);
              }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card title="Dev Mode" bordered={false}>
            <Switch
              checked={isDev}
              onChange={(checked) => {
                setIsDev(checked);
                handleToggleChange("isDev", checked);
              }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card title="Temporarily Open Survey" bordered={false}>
            <Switch
              checked={tempOpenSurvey}
              onChange={(checked) => {
                setTempOpenSurvey(checked);
                handleToggleChange("tempOpenSurvey", checked);
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Settings;
